<template>
  <router-link
    v-if="isAuthorized"
    :to="to"
    :replace="replace"
    :append="append"
    :tag="tag"
    :exact="exact"
    :event="event"
    :active-class="activeClass"
    :exact-active-class="exactActiveClass"
  >
    <a>{{ $t(msg_slug) }}</a>
  </router-link>
</template>

<script>
import router from "@/Router";

// Overwrite of router-link in order to conditionally display by authorization
export default {
  computed: {
    isAuthorized() {
      return this.$store.getters["auth/isAuthorized"];
    }
  },
  props: {
    to: {
      required: true
    },
    msg_slug: {
      required: true
    },
    authorization: {
      default: true
    },
    replace: {
      default: false
    },
    append: {
      default: false
    },
    tag: {
      default: "a"
    },
    event: {
      default: "click"
    },
    exact: {
      default: false
    },
    "active-class": {
      default: "router-link-active"
    },
    "exact-active-class": {
      default: "router-link-exact-active"
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/RouterLinkGuard.vue